import { Link } from 'react-router-dom';
import SectionHeader from '@/components/feature/SectionHeader';
import { newsList } from '@/mocks/news';

export default function NewsPreview() {
  const featured = newsList[0];
  const rest = newsList.slice(1, 6);

  return (
    <section className="w-full bg-background-50">
      <div className="mx-auto w-full max-w-portal px-4 py-10 md:px-6 md:py-14">
        <SectionHeader
          eyebrow="影视资讯"
          title="资讯精选"
          description="关注行业动态与热门剧集背后的故事。"
          moreLink="/news"
          moreText="进入资讯中心"
        />

        <div className="grid grid-cols-1 gap-6 lg:grid-cols-2">
          <Link
            to={`/news/${featured.id}`}
            className="group flex flex-col overflow-hidden rounded-lg border border-background-200 bg-background-50 transition-all duration-300 hover:border-primary-200"
          >
            <div className="h-52 w-full overflow-hidden md:h-64">
              <img
                src={featured.cover}
                alt={featured.title}
                title={`${featured.title} 影视仓资讯`}
                className="h-full w-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
              />
            </div>
            <div className="flex flex-1 flex-col p-5 md:p-6">
              <div className="flex flex-wrap items-center gap-2 text-xs">
                <span className="rounded-full bg-accent-100 px-2.5 py-0.5 font-medium text-accent-800">
                  {featured.category}
                </span>
                <span className="text-foreground-400">{featured.date}</span>
              </div>
              <h3 className="mt-3 font-heading text-lg font-bold leading-snug text-foreground-950 transition-colors group-hover:text-primary-600 md:text-xl">
                {featured.title}
              </h3>
              <p className="mt-2 line-clamp-2 text-sm leading-relaxed text-foreground-500">{featured.summary}</p>
            </div>
          </Link>

          <div className="flex flex-col divide-y divide-background-200 rounded-lg border border-background-200 bg-background-50 px-5 md:px-6">
            {rest.map((item) => (
              <Link
                key={item.id}
                to={`/news/${item.id}`}
                className="group flex flex-col gap-1.5 py-4 first:pt-5 last:pb-5"
              >
                <div className="flex flex-wrap items-center gap-2 text-xs">
                  <span className="rounded-full bg-secondary-100 px-2 py-0.5 font-medium text-secondary-900">
                    {item.category}
                  </span>
                  <span className="text-foreground-400">{item.date}</span>
                </div>
                <h4 className="line-clamp-2 font-heading text-sm font-bold leading-snug text-foreground-900 transition-colors group-hover:text-primary-600">
                  {item.title}
                </h4>
              </Link>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}